import CertificationJourneyLayout from './certification_journey_layout.jsx'

const CertificationJourneyPage = () => {
  return (
      <CertificationJourneyLayout />
  );
};

export default CertificationJourneyPage;